import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowUpFromBracketSharp = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 13.334V18h12v-4.666h2V20H4v-6.666h2Zm10.667-2.253-.707-.707L13 7.418v8.693h-2v-8.7l-2.959 2.962-.707.708L5.92 9.667l.707-.707 4.662-4.667.706-.707.708.707 4.671 4.666.708.707-1.414 1.415Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowUpFromBracketSharp);
export default Memo;
